import React, { useEffect } from 'react';
import { object, string, func, oneOfType } from 'prop-types';
import { useMediaStore } from '../store';

import { useAsyncServiceGCC } from '../hooks';
import { getMediaAssets } from '../api';

export default function MediaAssetsProvider({ data, omsId }) {
  const [{
    data: mediaAssets,
    ready: mediaAssetsHydrated
  }] = useAsyncServiceGCC(getMediaAssets, data?.data?.scene7Folder, omsId);
  const updateMediaAssets = useMediaStore((state) => state.updateMediaAssets);

  useEffect(() => {
    if (mediaAssetsHydrated) {
      updateMediaAssets({ ...mediaAssets });
    }
  }, [mediaAssets, mediaAssetsHydrated]);

  return (<div id="media-assets-provider" />);
}

MediaAssetsProvider.propTypes = {
  // TODO: PropType Shapes
  data: oneOfType([func, object]),
  omsId: string.isRequired,
};

MediaAssetsProvider.defaultProps = {
  data: {},
};
